export const SITE_NAME = 'VTGrid';
export const SITE_URL = 'https://vt-grid.com';